const IMG = "/images/wayflyer-intelligence";

export interface TimelineStep {
  title: string;
  blurb: string;
  questions: [string, string];
  media: string;
  mediaAlt: string;
  /** Which side the text card sits on at desktop; media takes the other side. */
  textSide: "left" | "right";
  /** object-position/size tweaks so the demo gif crops the same way as the design. */
  mediaClassName: string;
  dotColor: string;
}

export const TIMELINE_STEPS: TimelineStep[] = [
  {
    title: "Take a pulse check",
    blurb: "Where the business stands and where it’s heading.",
    questions: [
      "How did revenue trend across the last quarter?",
      "Where is cash flow tightest in the months ahead?",
    ],
    media: `${IMG}/pulse-check.gif`,
    mediaAlt: "Ask Intelligence demo",
    textSide: "left",
    mediaClassName: "size-full object-cover object-left-top",
    dotColor: "#fe634d",
  },
  {
    title: "Find out what’s driving it",
    blurb:
      "Whether your ad spend is working, and where to put the next dollar.",
    questions: [
      "Where should I double-down on ad spend?",
      "Meta vs. Google - where should we put our budget?",
    ],
    media: `${IMG}/roas-animated.gif`,
    mediaAlt: "ROAS chart",
    textSide: "right",
    mediaClassName:
      "absolute inset-0 h-full w-[158%] object-cover object-left-top -top-[5px]",
    dotColor: "#e842a3",
  },
  {
    title: "Know your customers",
    blurb: "Who’s buying, who’s coming back, and who’s worth keeping.",
    questions: [
      "Is our revenue drop a retention issue?",
      "Is my LTV:CAC healthy?",
    ],
    media: `${IMG}/ltv-chart-2x.gif`,
    mediaAlt: "LTV chart demo",
    textSide: "left",
    mediaClassName: "size-full w-[123%] object-cover object-left-top",
    dotColor: "#b033e0",
  },
  {
    title: "Back the winning products",
    blurb: "Which products are pulling their weight, and which aren’t.",
    questions: [
      "Is our growth too dependent on one hero product?",
      "How much inventory should I reorder?",
    ],
    media: `${IMG}/tile3-chart.gif`,
    mediaAlt: "Gross revenue chart demo",
    textSide: "right",
    mediaClassName:
      "absolute inset-0 h-full w-[124%] object-cover object-left-top -left-[5px]",
    dotColor: "#5e1fff",
  },
  {
    title: "Make the call",
    blurb: "What to do next, backed by your own data.",
    questions: [
      "How could we scale revenue 10% next year?",
      "What should I do next month to set up the best Q4?",
    ],
    media: `${IMG}/scale-revenue.gif`,
    mediaAlt: "Scale revenue answer demo",
    textSide: "left",
    mediaClassName: "size-full object-cover object-left-top",
    dotColor: "#001fff",
  },
];

export const TIMELINE_DOT_COLORS = TIMELINE_STEPS.map((s) => s.dotColor);

/** Snap targets as a fraction of pinned scroll progress: 0/24/48/72/100%.
 * The last step ends the track exactly (not 96%) so resting on it doesn't
 * leave a trailing stretch of scroll where the track is still finishing
 * but nothing on screen has changed yet. */
export const TIMELINE_SNAP_TARGETS = [0, 0.24, 0.48, 0.72, 1];
